import '../../scss/OverViewExam.scss'
import { Button } from "primereact/button";
import { useEffect, useState, useRef } from 'react';
import { dangbaiService } from 'services/dangbaiService';
import { ProgressSpinner } from 'primereact/progressspinner';
import { dethitructuyenService } from 'services/dethitructuyenService';
import { Dialog } from 'primereact/dialog';
import { Player, ControlBar } from 'video-react';
import 'video-react/dist/video-react.css';
import he from 'he';
import { useNavigate } from 'react-router-dom';
import { getExamProgress, getNextExamType } from 'utils/examProgress';
import { ThiTrucTuyenService } from 'services/ThiTrucTuyenService';
import { FaUser, FaSignOutAlt } from "react-icons/fa";


const OverViewExam = (props) => {
    var userId = localStorage.getItem('User_Id');
    const username = localStorage.getItem('fullname');
    const IdDeThi = localStorage.getItem('IdDeThi');
    const typ = localStorage.getItem('typeExam');

    if (IdDeThi == null || IdDeThi == "" || userId == null || username == "" || username == null) {
        window.location.href = '/'
    }

    const [type, setType] = useState(typ || "");
    const [socauhoi, setSoCauHoi] = useState(1);
    const [thoigian, setThoiGian] = useState(0);
    const [loading, setLoading] = useState(false);
    const [textUrl, setTextUrl] = useState('');
    const [textDes, setTextDes] = useState('');
    const [showPopup, setShowPopup] = useState(false);
    const [showForceFullscreen, setShowForceFullscreen] = useState(false);
    const [playbackRate, setPlaybackRate] = useState(1); // Tốc độ phát mặc định
    const [showSelect, setShowSelect] = useState(false); // Trạng thá
    const navigate = useNavigate();

    const handleShowPopup = () => {
        setShowPopup(true);
    };

    const handleHidePopup = () => {
        setShowPopup(false);
    };

    const requestFullScreen = async () => {
        try {
            const el = document.documentElement;
            if (document.fullscreenElement) return true;
            if (el?.requestFullscreen) {
                await el.requestFullscreen();
                return true;
            }
        } catch (e) {
            // Browser có thể chặn (policy/permission)
        }
        return false;
    };

    const loadData = async () => {
        setLoading(true);
        localStorage.setItem('arrBookMark', JSON.stringify([]));
        var typeExam = localStorage.getItem('typeExam');

        var body = {
            code: typeExam,
            kyThiId: localStorage.getItem('CaThiId') || localStorage.getItem('KyThiId') || null
        }
        let result = await dangbaiService.getdetail(body);
        if (result.data) {
            setType(result.data.data.ma);
            setSoCauHoi(result.data.data.socauhoi);
            let time = parseInt(result.data.data.thoigian);
            setThoiGian(time);
            localStorage.setItem('countDown', time * 60);
        }
        setLoading(false);

    }

    useEffect(() => {
        // Kiểm tra và khôi phục typeExam đúng từ getNextExamType()
        const checkAndSetCorrectTypeExam = async () => {
            const dethiId = localStorage.getItem('IdDeThi');

            // Luôn gọi API để xác định phase chính xác từ DB
            // (tránh mất state khi iOS/mobile purge localStorage hoặc user thao túng DevTools)
            try {
                const resumeRes = await ThiTrucTuyenService.checkResumeAttempt({
                    user_id: userId,
                    dethitructuyen_id: dethiId
                });
                const dataResume = resumeRes?.data;
                const completedTypes = dataResume?.completed_types || [];
                const isNoiCompleted = completedTypes.includes('NOI');

                if (!isNoiCompleted) {
                    // Phase 1: NOI chưa xong → bắt buộc NOI
                    localStorage.setItem('typeExam', 'NOI');
                    localStorage.setItem('exam_mode', 'speaking_only');
                    if (dataResume?.has_unfinished && dataResume?.attempt_code) {
                        localStorage.setItem('exam_attempt_code', dataResume.attempt_code);
                    }
                    setType('NOI');
                    await loadData();
                    return;
                }

                // Phase 2: NOI đã xong → khôi phục progress và tìm dạng tiếp theo
                localStorage.setItem('exam_mode', 'full_exam');

                // Import động để tránh circular dependency
                const { initExamProgress, getExamProgress: getProgress, markExamTypeCompleted, getNextExamType: getNext } = await import('utils/examProgress');

                // Khôi phục progress từ DB nếu chưa có trong localStorage
                let progress = getProgress();
                const progressDethiId = progress ? String(progress.dethiId) : null;
                const currentDethiId = String(dethiId);

                if (!progress || progressDethiId !== currentDethiId) {
                    initExamProgress(dethiId);
                    // Đánh dấu các dạng đã hoàn thành từ DB (bao gồm NOI từ Phase 1)
                    if (completedTypes.length > 0) {
                        completedTypes.forEach(t => markExamTypeCompleted(t));
                    }
                } else if (dataResume?.has_unfinished && dataResume?.attempt_code) {
                    // Resume attempt đang dở
                    localStorage.setItem('exam_attempt_code', dataResume.attempt_code);
                    // Đảm bảo NOI được mark dù progress đã tồn tại
                    completedTypes.forEach(t => markExamTypeCompleted(t));
                }

                const nextExamType = getNext();
                if (nextExamType) {
                    localStorage.setItem('typeExam', nextExamType);
                    setType(nextExamType);
                }
            } catch (e) {
                // Nếu API lỗi, fallback về exam_mode hiện tại trong localStorage
                console.error('checkAndSetCorrectTypeExam error', e);
                const examMode = localStorage.getItem('exam_mode');
                if (examMode === 'speaking_only') {
                    localStorage.setItem('typeExam', 'NOI');
                    setType('NOI');
                }
            }

            // Load data sau khi đã set typeExam đúng
            await loadData();
        };

        checkAndSetCorrectTypeExam();
    }, []);

    // Best-effort: không thể khóa cứng 100% fullscreen do giới hạn trình duyệt,
    // nhưng nếu user thoát fullscreen thì sẽ bật modal yêu cầu bật lại.
    useEffect(() => {
        // Đánh dấu đang trong màn thi để tự động bật lại fullscreen sau khi reload
        sessionStorage.setItem('exam_fullscreen_required', 'true');

        // Kiểm tra và bật fullscreen (bao gồm cả sau khi reload)
        const checkAndRequestFullscreen = async () => {
            if (!document.fullscreenElement) {
                const success = await requestFullScreen();
                if (!success) {
                    // Nếu không bật được, hiển thị Dialog yêu cầu user click
                    setShowForceFullscreen(true);
                }
            }
        };

        checkAndRequestFullscreen();

        const onFsChange = async () => {
            if (document.fullscreenElement) {
                setShowForceFullscreen(false);
            } else {
                // Tự động bật lại fullscreen ngay khi user cố tắt
                const success = await requestFullScreen();
                if (!success) {
                    setShowForceFullscreen(true);
                }
            }
        };
        document.addEventListener('fullscreenchange', onFsChange);
        return () => document.removeEventListener('fullscreenchange', onFsChange);
    }, []);


    const renderTitle = (type) => {
        if (type == "NGUPHAP") {
            return "Grammar and Vocabulary";
        }
        else if (type == "NGHE") {
            return "Listening";
        }
        else if (type == "DOC") {
            return "Reading";
        }
        else if (type == "VIET") {
            return "Writing";
        }
        else {
            return "Speaking";
        }
    }

    const openStart = async () => {
        if (type != "" && type != undefined) {
            // Gọi fullscreen trước khi navigate (đang trong user gesture từ click button)
            await requestFullScreen();
            // Dùng navigate thay vì window.location.href để giữ fullscreen tốt hơn
            navigate('/examdetail');
        }

    }

    const handleLogout = () => {
        localStorage.clear();
        sessionStorage.clear();
        navigate('/');
    }

    useEffect(() => {
        const styleSheet = document.createElement('style');
        styleSheet.type = 'text/css';
        styleSheet.innerHTML = `
          @keyframes blink {
            0%, 100% { opacity: 1; }
            50% { opacity: 0.5; }
          }
        `;
        document.head.appendChild(styleSheet);
    }, []);

    useEffect(() => {
        // loadDataFile();
    }, [IdDeThi, type])

    const loadDataFile = async () => {
        const body = {
            code: type,
            dethi_id: IdDeThi
        }
        let result = await dethitructuyenService.getMoTaDeThi(body);
        if (result?.data) {
            // window.open(result?.data.data.file, "_blank");
            setTextUrl(result?.data.data.file);
            setTextDes(result?.data.data.des)
        }
    }

    const openKey = async () => {
        handleShowPopup(true);
    }

    const playerRef = useRef(null);

    useEffect(() => {
        // Thiết lập tốc độ phát mặc định khi video load
        if (playerRef.current && playerRef.current.video.video) {
            playerRef.current.video.video.playbackRate = playbackRate;
        }
    }, [playbackRate]); // Khi tốc độ phát thay đổi

    // Hàm thay đổi tốc độ phát
    const handleChange = (event) => {
        const rate = parseFloat(event.target.value);
        setPlaybackRate(rate);
    };

    const renderKey = (fileUrl) => {
        const extension = fileUrl.split('.').pop().toLowerCase();
        switch (extension) {
            case 'mp4':
                return (
                    <div className="video-container">
                        <Player
                            ref={playerRef}
                            playsInline
                            src={fileUrl}
                            autoPlay
                            loop
                            style={{
                                width: '100%',
                                height: '100%',
                                maxWidth: '100%',
                                maxHeight: '100%',
                                objectFit: 'cover',
                            }}

                        >
                            <ControlBar autoHide={true}
                                onMouseEnter={() => setShowSelect(true)} // Hiện select khi hover
                                onMouseLeave={() => setShowSelect(false)} // Ẩn select khi rời khỏi
                            />
                        </Player>

                        {/* {showSelect && ( // Chỉ hiển thị khi hover vào ControlBar */}
                        <div
                            className="custom-controls"
                            style={{
                                position: 'absolute',
                                bottom: '50px', // Điều chỉnh khoảng cách so với ControlBar
                                right: '20px',
                                zIndex: 10,
                                backgroundColor: 'red'
                            }}
                        >
                            <select
                                value={playbackRate}
                                onChange={handleChange}
                                style={{
                                    padding: '5px',
                                    borderRadius: '5px',
                                    backgroundColor: '#fff',
                                }}
                            >
                                <option value={0.5}>0.5x</option>
                                <option value={1}>1x (Normal)</option>
                                <option value={1.5}>1.5x</option>
                                <option value={2}>2x</option>
                            </select>
                        </div>
                        {/* )} */}

                        <style>
                            {`
                            .video-container:hover .custom-controls {
                                opacity: 1;
                            }
                            .custom-controls {
                                opacity: 0; /* Ẩn theo mặc định */
                            }
                            `}
                        </style>

                    </div>
                );
            case 'mp3':
                return (
                    <div>
                        <audio controlsList="nodownload" controls key={fileUrl}>
                            <source src={fileUrl} type="audio/ogg" />
                            <source src={fileUrl} type="audio/mpeg" />
                        </audio>
                    </div>
                );
            default:
                return (
                    <iframe

                        src={`${fileUrl}#toolbar=0`}
                        title="File Viewer"
                        style={{ width: '100%', height: '100%', border: 'none' }}
                    />
                );
        }
    }


    return (
        <div >
            {/* Header bar với logo và logout */}
            <div style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                height: '60px',
                backgroundColor: '#fff',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                padding: '0 20px',
                zIndex: 1000,
                boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                borderBottom: '1px solid #e5e7eb'
            }}>
                {/* Logo/Brand */}
                <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '12px'
                }}>
                    <div style={{
                        width: '40px',
                        height: '40px',
                        backgroundColor: '#23085a',
                        borderRadius: '8px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontWeight: 'bold',
                        color: '#fff',
                        fontSize: '18px'
                    }}>
                        A
                    </div>
                    <span style={{ color: '#23085a', fontSize: '18px', fontWeight: '600' }}>
                        Aptis Exam
                    </span>
                </div>

                {/* User info và logout */}
                <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '16px'
                }}>
                    <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                        color: '#333'
                    }}>
                        <FaUser size={16} />
                        <span style={{ fontSize: '14px' }}>{username}</span>
                    </div>
                    <Button
                        icon={<FaSignOutAlt size={14} />}
                        label="Logout"
                        onClick={handleLogout}
                        style={{
                            backgroundColor: '#23085a',
                            border: '1px solid #23085a',
                            color: '#fff',
                            fontSize: '14px',
                            padding: '6px 16px'
                        }}
                        className="p-button-sm"
                    />
                </div>
            </div>

            {/* Spacer để content không bị che bởi fixed header */}
            <div style={{ height: '60px' }}></div>

            <Dialog
                header="Yêu cầu chế độ toàn màn hình"
                visible={showForceFullscreen}
                closable={false}
                draggable={false}
                resizable={false}
                modal
                style={{ width: 'min(560px, 95vw)' }}
                footer={
                    <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 10, paddingTop: 4 }}>
                        <Button
                            label="Bật lại toàn màn hình"
                            icon="pi pi-window-maximize"
                            className="p-button"
                            style={{
                                background: '#23085a',
                                borderColor: '#23085a',
                                boxShadow: '0 10px 18px rgba(35, 8, 90, 0.22)'
                            }}
                            onClick={async () => {
                                const ok = await requestFullScreen();
                                setShowForceFullscreen(!ok);
                            }}
                        />
                    </div>
                }
            >
                <div style={{ display: 'flex', gap: 14, lineHeight: 1.5, padding: '6px 2px 2px 2px' }}>
                    <div
                        style={{
                            width: 44,
                            height: 44,
                            borderRadius: 12,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            background: 'rgba(35, 8, 90, 0.08)',
                            color: '#23085a',
                            flex: '0 0 auto'
                        }}
                    >
                        <i className="pi pi-window-maximize" style={{ fontSize: 18 }} />
                    </div>
                    <div style={{ flex: 1 }}>
                        <div style={{ fontSize: 16, fontWeight: 700, color: '#111827', marginBottom: 6 }}>
                            Vui lòng bật chế độ toàn màn hình để tiếp tục
                        </div>
                        <div style={{ fontSize: 14, color: '#4b5563' }}>
                            Bạn đang thoát khỏi toàn màn hình. Bấm <b>Bật lại toàn màn hình</b> để quay lại và tiếp tục xem phần giới thiệu.
                        </div>
                        <div style={{ marginTop: 10, fontSize: 12, color: '#6b7280' }}>
                            Mẹo: Nếu trình duyệt chặn, hãy thử bấm lại nút một lần nữa.
                        </div>
                    </div>
                </div>
            </Dialog>
            {
                !loading ?
                    <div style={{ marginLeft: '15%' }} className='container'>
                        <div className='col-lg-12 row'>
                            <div className='col-lg-12'>
                                <h6 className=" mb-2 mt-4">Aptis General Practice Test</h6>
                                <h5 className=" mt-0 mb-5">{renderTitle(type)}</h5>
                                <div className="mt-0 mb-4 d-flex" >
                                    <div className="mr-5  flex-column d-flex">
                                        <span className="mb-1">Number of Questions</span>
                                        <strong>{socauhoi}</strong>
                                    </div>
                                    {type != "NOI" &&
                                        <div className="mx-5  flex-column d-flex">
                                            <span className="mb-1">Time Allowed</span>
                                            <strong>{thoigian} min</strong>
                                        </div>
                                    }

                                </div>
                                <div className="assessment-description flex-column row mt-0 mb-4">
                                    <strong className="mb-1 mt-0">Assessment Description</strong>
                                    <p className="my-0"> </p>
                                </div>
                                {/* <div className="form-description flex-column row mt-0 mb-5">
                                    <strong className="mb-1 mt-0">Form Description</strong>
                                    <p className="my-0"> </p>
                                </div> */}
                                <Button className="btn2 mt-2" style={{ width: '200px', backgroundColor: "#23085a", color: 'white', textAlign: 'center' }}
                                    onClick={() => openStart()}
                                >
                                    <div className="d-flex justify-content-center align-items-center" style={{ width: '100%' }}>
                                        <span className="mr-2">Start Exam</span>
                                    </div>
                                </Button>
                            </div>

                        </div>

                    </div>
                    :
                    <div style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: '80vh',
                        flexDirection: 'column',
                        textAlign: 'center'
                    }}>
                        <ProgressSpinner />
                    </div>
            }
            <Dialog
                header=""
                visible={showPopup}
                style={{ width: '80vw', height: '90vh' }}
                onHide={handleHidePopup}
            >
                <div style={{
                    width: '100%', // Hoặc đặt kích thước cụ thể nếu cần
                    height: '100%', // Đảm bảo kích thước thẻ chứa
                    // overflow: 'hidden', // Ẩn các phần video vượt ra ngoài
                }}>
                    {renderKey(textUrl)}
                </div>

            </Dialog>
        </div>
    )
}

export default OverViewExam;